import * as React from 'react'
import './src/global.css'
import Base from './src/components/layouts/base'

export const wrapPageElement = ({ element, props }) => {
  return <Base {...props}>{element}</Base>
}
